import { render, staticRenderFns } from "./chengshidanao.vue?vue&type=template&id=02364794&scoped=true&"
import script from "./chengshidanao.vue?vue&type=script&lang=js&"
export * from "./chengshidanao.vue?vue&type=script&lang=js&"
import style0 from "./chengshidanao.vue?vue&type=style&index=0&id=02364794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02364794",
  null
  
)

export default component.exports